import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
	CreateTransportEventRequest,
	CreateTransportEventResponse,
} from '@/new-transport/transport-timetable/transport-event/transport-event.model';

export enum ResourceName {
	TOURISM_EVENTS = 'tourismEvents',
	VEHICLES = 'vehicles',
	DRIVERS = 'drivers',
}

@Injectable({
	providedIn: 'root',
})
export class TransportEventApiService {
	private readonly http = inject(HttpClient);

	createTourismEvent(tourismEventData: CreateTransportEventRequest): Observable<CreateTransportEventResponse> {
		return this.http.post<CreateTransportEventResponse>(
			`${environment.erpSymfonyUrl}/tourismEvent/create/antenna`,
			tourismEventData,
		);
	}

	search<T>(resourceName: ResourceName, searchBy: string, side?: string): Observable<T[]> {
		const endpoint = `${resourceName}/search?by=${searchBy}&omitHistoric=true&side=${side}`;

		return this.http.get<T[]>(`${environment.erpSymfonyUrl}/${endpoint}`);
	}
}
